import React, { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import Swal from 'sweetalert2'; // Import SweetAlert
import * as XLSX from 'xlsx';
import { Backdrop, Button, Dialog, DialogContent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress from Material-UI

import { useFilter } from '../../layouts/dashboard/FilterProvider';
import zodiacApiFunctions from '../../API/zodiacApi';

const DownloadZodiacReport = () => {
  const { filter } = useFilter();

  const [loading, setLoading] = useState(false);
  const Popup = () => {
    Swal.fire({
      title: 'Download Report',
      text: 'Do you want to download the report?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDownload();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User clicked "No, cancel"
        Swal.fire('Cancelled', 'The download request was cancelled.', 'info');
      }
    });
  };
  const convertToIndianTime = (utcDateString) => {
    const utcDate = new Date(utcDateString);
    const indianTime = utcDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    return indianTime;
  };
  const getZodiacSign = (zodiacKey) => {
    const zodiacSigns = [
      { code: 101, name: 'Aries' },
      { code: 102, name: 'Taurus' },
      { code: 103, name: 'Gemini' },
      { code: 104, name: 'Cancer' },
      { code: 105, name: 'Leo' },
      { code: 106, name: 'Virgo' },
      { code: 107, name: 'Libra' },
      { code: 108, name: 'Scorpio' },
      { code: 109, name: 'Sagittarius' },
      { code: 110, name: 'Capricorn' },
      { code: 111, name: 'Aquarius' },
      { code: 112, name: 'Pisces' },
    ];

    const zodiacMatch = zodiacSigns.find((sign) => sign.code === zodiacKey);
    return zodiacMatch ? zodiacMatch.name : null;
  };
  // Clean and process the Excel data

  const handleDownload = async () => {
    try {
      setLoading(true);
      const data = await zodiacApiFunctions.getExcelData(filter);
      // console.log(data, 'data');

      const excelArray = data.excelData.map((entry) => {
        const isCouple = entry.Marital === 1;
        const cleanedEntry = {
          Name: entry.Name,
          Mobile: entry.Mobile,
          MaritalStatus: isCouple ? 'Couple' : 'Single',
          DOB: new Date(entry.DOB).toLocaleDateString(),
          'Partner DOB': entry.PDOB != null ? new Date(entry.PDOB).toLocaleDateString() : null,
          Anniversary: entry.Anniversary != null ? new Date(entry.Anniversary).toLocaleDateString() : null,
          UserZodiacSign: getZodiacSign(entry.UserZodiacKey),
          PartnerZodiacSign: getZodiacSign(entry.PartnerZodiacKey),
          createdAt: convertToIndianTime(entry.createdAt),
        };

        return cleanedEntry;
      });
      console.log(excelArray.slice(0, 10), 'cleaned');
      const worksheet1 = XLSX.utils.json_to_sheet(excelArray);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet1, 'User Details');
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      setLoading(false);
      Swal.fire({
        icon: 'info',
        title: 'Download Started',
        text: 'Your download has started.',
        showConfirmButton: false, // Prevent the user from closing it manually
      });

      // Create a Blob from the buffer and download the file
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'Mia_Zodiac_Details.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel:', error);
    }
  };

  return (
    <div>
      <Button onClick={Popup} style={{ color: '#D24A61', height: '40px' }}>
        <AiOutlineDownload style={{ width: 'auto', height: '22px' }} /> &#160; Download Report
      </Button>

      <Dialog open={loading} maxWidth="false">
        <DialogContent style={{ background: 'white', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress style={{ color: '#D24A61' }} size={60} thickness={4} />{' '}
            {/* Display the loader when loading is true */}
          </div>
          <br />
          Generating Report...
        </DialogContent>
      </Dialog>
      <Backdrop open={loading} />
    </div>
  );
};
export default DownloadZodiacReport;
